var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34092_14596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.50004 16.6667V17.1667H5.00004H15H15.5V16.6667V6.66666V6.2071L16.1667 6.87376V16.6667C16.1667 17.3072 15.6406 17.8333 15 17.8333H5.00004C4.35952 17.8333 3.83337 17.3072 3.83337 16.6667V3.33332C3.83337 2.6928 4.35952 2.16666 5.00004 2.16666H11.4596L15.4596 6.16666H15H11.3334V3.33332V2.83332H10.8334H5.00004H4.50004V3.33332V16.6667ZM10.8334 14.5H10.3334V15V15.3333H9.66671V15V14.5H9.16671H8.00004V13.8333H10.8334H11.3334V13.3333V12.5V12H10.8334H8.33337C8.15118 12 8.00004 11.8488 8.00004 11.6667V9.16666C8.00004 8.98447 8.15118 8.83332 8.33337 8.83332H9.16671H9.66671V8.33332V7.99999H10.3334V8.33332V8.83332H10.8334H12V9.49999H9.16671H8.66671V9.99999V10.8333V11.3333H9.16671H11.6667C11.8489 11.3333 12 11.4845 12 11.6667V14.1667C12 14.3488 11.8489 14.5 11.6667 14.5H10.8334Z",
    fill: "#7100DA",
    stroke: "#7100DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34092_14596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestQuote);
export default __webpack_public_path__ + "static/media/request_quote.b70f68468eeb1bd2e60b1ab8c81f7f7f.svg";
export { ForwardRef as ReactComponent };